import { Event } from "@ailenax-overlay/shared";
import { useSocket } from "./useSocket";
import { useEffect } from "react";

export const useSocketEvent = <E extends Event["event"]>(eventName: E, callback: (event: Extract<Event, { event: E }>) => void) => {
    const socket = useSocket();

    useEffect(() => {
        // @ts-expect-error callback works
        socket.on(eventName, callback);

        return () => {
            // @ts-expect-error callback works
            socket.off(eventName, callback);
        }
    }, [socket, eventName, callback]);
}